#ifdef GL_ES
precision mediump float;
#endif

#pragma glslify: snoise = require('../partials/snoise.glsl')

#pragma glslify: fbm = require('../partials/fbm.glsl')
uniform float u_time;
uniform float u_r;
uniform float opacity;

varying vec3 vColor;
varying float vRandomValue;
varying float vAngle;
varying vec3  vPos;

void main() {
    vec2 coord = gl_PointCoord - vec2(0.5);
    float nBorder = snoise(coord * 2.0 + vRandomValue * 0.5);
    float distortion = nBorder * 0.4;
    coord += distortion;
    float dist = length(coord);
    if (dist > 0.5) discard;
    float gradient = smoothstep(0.2, 0.5, dist);

    vec2 st = coord;
    float c = cos(vAngle), s = sin(vAngle);
    vec2 stRot = vec2(
      st.x * c - st.y * s,
      st.x * s + st.y * c
    );
    stRot.x *= -1.5;

    float phase = u_time - vAngle;
    float n = fbm(stRot * -4.0 + phase, vRandomValue);

    vec3 colorRGB = vColor * (0.5 + 0.5 * n);
    float alphaFinal = (1.0 - gradient) * n * opacity;

    gl_FragColor = vec4(colorRGB, alphaFinal);
}
